var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"clearfix"}),_vm._v(" "),_c('top-category-form',{attrs:{"route":_vm.route},on:{"on-submit":_vm.onCategorySubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b6a04b9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/TopCategories/TopCategoryEdit.vue
// module id = LIBP
// module chunks = 1